/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyImplantStock from './pharmacy-implant-stock';
import PharmacyImplantStockDetail from './pharmacy-implant-stock-detail';
import PharmacyImplantStockUpdate from './pharmacy-implant-stock-update';
import PharmacyImplantStockDeleteDialog from './pharmacy-implant-stock-delete-dialog';

const PharmacyImplantStockRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyImplantStock />} />
    <Route path="new" element={<PharmacyImplantStockUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyImplantStockDetail />} />
      <Route path="edit" element={<PharmacyImplantStockUpdate />} />
      <Route path="delete" element={<PharmacyImplantStockDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyImplantStockRoutes;
